<app-container class="flex justify-center container" maxWidth="552px">
  <app-card [title]="'Dodaj zdjęcie, plik'" [titleStyle]="{'text-align': 'left'}"
            [subtitleStyle]="{'text-align': 'left'}"
            [subtitle]="(files.length === 0) ? 'Dodaj dokument wydatku lub jego skan (jeden lub wiele stron).':
              'Dodaj kolejny plik lub przejdź dalej.'" height="612.797px">
    <div content>
      <ngx-file-drop
        dropZoneClassName="file-drop-zone"
        contentClassName="file-drop-content"
        (onFileDrop)="addDroppedFile($event)"
        (onFileOver)="showDropArea()"
        (onFileLeave)="hideDropArea()">
        <ng-template ngx-file-drop-content-tmp>
          <label for="fileButton" class="drag-and-drop-content" id="file-area" matRipple>
            <div class="content-wrapper">
              <app-icon name="cloud_upload_24" size="72" color="#575481" class="mb-6"></app-icon>
              <span class="description" appGtmFormEvent [eventField]="'file'" [eventForm]="formName">
                <div class="mb-4">Upuść plik tutaj lub <a class="bold">kliknij by dodać</a></div>
                <div class="secondary-text">(tylko w formacie JPG, JPEG, PNG, PDF do 5 MB)</div>
                <label for="fileButton" class="cdk-visually-hidden">Plik</label>
                <input
                  #fileInput
                  type="file"
                  id="fileButton"
                  class="not-displayed"
                  (change)="filesAdded($event); fileInput.value = null"
                  appGtmFormEvent
                  [eventField]="'file'"
                  [eventForm]="formName"
                />
              </span>
            </div>
          </label>
        </ng-template>
      </ngx-file-drop>

      <mat-error *ngIf="error" class="pt-10 pl-2">
        <span class="error">{{ error }}</span>
      </mat-error>

      <button class="not-displayed" type="submit">hidden submit</button>

      <div *ngFor="let file of files; let i = index">
        <app-added-file-row
          [file]="file"
          [index]="i"
          [remove]="remove"
          (showPreview)="documentPreviewVisible = true"
        ></app-added-file-row>
      </div>

    </div>
    <div buttons class="flex flex-col">
      <app-new-loader-button
        class="big-button button-250 self-center"
        color="accent"
        [customType]="LoaderButtonType.RAISED"
        [disabled]="disabled"
        cdkFocusInitial
        buttonType="submit"
        (buttonClick)="submit()">
        Dalej
      </app-new-loader-button>
      <button type="button" mat-button class="self-center font-bold font-medium primary-color "
              style="width: 250px;" routerLink="../">
        Wróć
      </button>
    </div>
  </app-card>
</app-container>

<app-document-preview
  *ngIf="documentPreviewVisible"
  [files]="files"
  [remove]="remove"
  (hidePreview)="documentPreviewVisible = false"
></app-document-preview>
